import { render, staticRenderFns } from "./JoinEvent.vue?vue&type=template&id=53466085&scoped=true&"
import script from "./JoinEvent.vue?vue&type=script&lang=js&"
export * from "./JoinEvent.vue?vue&type=script&lang=js&"
import style0 from "./JoinEvent.vue?vue&type=style&index=0&id=53466085&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53466085",
  null
  
)

export default component.exports